import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { StateService } from '@uirouter/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ModalService } from 'src/app/components/modals/modal.service';
import { FeaturesService } from 'src/app/components/plans/features.service';
import { ComponentsModule } from 'src/app/components/components.module';
import { StatusBadgeComponent } from 'src/app/components/status-badge/status-badge.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { UsernamePipe } from 'src/app/shared/pipes/username.pipe';
import { ComponentsService } from '../../services/components.service';
import { TemplateEditorService } from '../../services/template-editor.service';
import { PresentationOrientationSelectorComponent } from '../presentation-orientation-selector/presentation-orientation-selector.component';
import { ScheduleSelectorService } from 'src/app/schedules/services/schedule-selector.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';

@Component({
  selector: 'template-editor-toolbar',
  templateUrl: './template-editor-toolbar.component.html',
  styleUrls: ['./template-editor-toolbar.component.scss'],
  host: {
    class: 'tw-flex tw-flex-1 tw-min-w-0 tw-items-center',
  },
  imports: [
    CommonModule,
    ComponentsModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    PresentationOrientationSelectorComponent,
    SharedModule,
    StatusBadgeComponent,
  ],
  providers: [DatePipe],
})
export class TemplateEditorToolbarComponent {
  protected isPublicationApprovalAvailable = false;
  public schedulesComponent;
  private datePipe = inject(DatePipe);
  private usernamePipe = inject(UsernamePipe);

  constructor(
    private modalService: ModalService,
    public templateEditorFactory: TemplateEditorService,
    public componentsService: ComponentsService,
    private featuresService: FeaturesService,
    private scheduleSelectorService: ScheduleSelectorService,
    private userStateService: UserStateService,
    private stateService: StateService,
  ) {
    this.isPublicationApprovalAvailable =
      this.featuresService.isFeatureAvailable(
        FeaturesService.FEATURE_PUBLICATION_APPROVAL,
      );

    if (this.userStateService.hasPermission('cp ap')) {
      this.schedulesComponent =
        this.scheduleSelectorService.getSchedulesComponent(
          this.templateEditorFactory.presentation,
        );
    }
  }

  newPresentation(): void {
    this.stateService.go('apps.editor.create');
  }

  confirmDelete() {
    this.modalService
      .confirmDanger(
        'Are you sure you want to delete this Presentation?',
        null,
        'Delete Forever',
      )
      .then(() => {
        this.templateEditorFactory.deletePresentation();
      });
  }

  openSettings() {
    let page = this.componentsService.getCurrentPage();
    if (!page || page.type !== 'rise-template-share-settings') {
      this.componentsService.editComponent({
        type: 'rise-template-share-settings',
      });
    }
  }

  editSchedules(): void {
    if (this.schedulesComponent) {
      this.componentsService.editComponent(this.schedulesComponent);
    }
  }

  getSavedTooltipText() {
    return `Saved ${this.datePipe.transform(
      this.templateEditorFactory.presentation.changeDate,
      'MMM d yyyy h:mm a',
    )} by ${this.usernamePipe.transform(
      this.templateEditorFactory.presentation.changedBy,
    )}`;
  }
}
